export enum UnsavedChangesOptions {
  SAVE,
  DISCARD,
  STAY
}